"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KettenSerie = void 0;
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const Serie_1 = require("../Serie");
const echain_product_models_1 = require("@igus/echain-product-models");
class KettenSerie extends Serie_1.Serie {
    get kuerzel() {
        return this.model.Kuerzel;
    }
    get seriesType() {
        return echain_product_models_1.ArticleType.kette;
    }
    get system() {
        var _a, _b;
        return {
            id: (_a = this.model.System) === null || _a === void 0 ? void 0 : _a.Id,
            kuerzel: (_b = this.model.System) === null || _b === void 0 ? void 0 : _b.Kuerzel,
        };
    }
    set system(value) {
        this.model.System = {
            Id: value.id,
            Kuerzel: value.kuerzel,
        };
    }
    get rinnenvariante() {
        var _a;
        return (_a = this.model.Rinnenvariante) === null || _a === void 0 ? void 0 : _a.map((v) => {
            return {
                name: v.Name,
                rinneRef: v.RinneRef,
                montagesetRef: v.MontagesetRef,
            };
        });
    }
    set rinnenvariante(values) {
        this.model.Rinnenvariante = values
            ? values.map((v) => {
                return {
                    Name: v.name,
                    RinneRef: v.rinneRef,
                    MontagesetRef: v.montagesetRef,
                };
            })
            : [];
    }
    get rolEchainParts() {
        var _a;
        return (_a = this.model.RolEchainParts) === null || _a === void 0 ? void 0 : _a.map((v) => {
            return {
                name: v.Name,
                numStandardLinks: v.NumKG,
                numRolLinks: v.NumRKG,
                numAdapterLinks: v.NumAKG,
            };
        });
    }
    get langerWegZeichnungsnummer() {
        return this.model.LangerWegZeichnungsnummer;
    }
    get ketteSerieType() {
        return this.model.KetteSerieType;
    }
    static fromScratch(ketteSerieType = echain_shared_articles_1.KetteSerieType.default) {
        return new KettenSerie({ KetteSerieType: ketteSerieType });
    }
    static fromJson(json) {
        const serie = KettenSerie.fromScratch();
        serie.fromJson(json);
        return serie;
    }
    toModel() {
        return this.model;
    }
}
exports.KettenSerie = KettenSerie;
//# sourceMappingURL=KettenSerie.js.map